module.exports = __webpack_public_path__ + "static/quick-order-static-c95ded2307c6dff855a1035e1f593d21.png";